import { Box, Text } from '@chakra-ui/react'
import { NewsletterForm } from '@forms'
import { IFonts } from '@interfaces'

interface INewsletterBox {
  title: string
  description1: string
  description2: string
  buttonLabel: string
  activeFontFamily?: IFonts
}

const NewsletterBox = ({
  title,
  description1,
  description2,
  buttonLabel,
  activeFontFamily = 'body',
}: INewsletterBox) => {
  return (
    <Box
      width="full"
      bgColor="white.primary2"
      pl={{ base: 'padding.primary', lg: 'padding.primary2' }}
      pr="0"
      py="0"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Box pt="padding.primary2" pr={{ base: 'padding.primary', lg: 'padding.primary2' }}>
        <Text
          color="red.primary"
          mb={4}
          fontSize={{ base: 'xl', lg: '2xl' }}
          fontFamily={activeFontFamily}
          fontWeight="regular"
        >
          {title}
        </Text>
        <Text
          color="black.primary3"
          fontWeight="light"
          fontFamily={activeFontFamily}
          fontSize="md"
        >
          {description1}
        </Text>
        <Text
          color="black.primary3"
          fontWeight="light"
          fontFamily={activeFontFamily}
          fontSize="md"
        >
          {description2}
        </Text>
      </Box>
      <NewsletterForm
        buttonLabel={buttonLabel}
        activeFontFamily={activeFontFamily}
      />
    </Box>
  )
}

export default NewsletterBox
